import { NotifyHelper } from "../../../../helpers/toast";
import { eChuDeThiInActionsObj } from "../../../action-types/de-thi/de-thi-in/IChuDeThiInActions";
import { generateActionForKey, generateActions } from "../../generateActions";

export const chuDeThiActions = {
  ...generateActions(eChuDeThiInActionsObj, "CHU_DE_THI_IN"),
  ...generateActionForKey(
    eChuDeThiInActionsObj,
    "CHU_DE_THI_IN",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eChuDeThiInActionsObj,
    "CHU_DE_THI_IN",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eChuDeThiInActionsObj,
    "CHU_DE_THI_IN",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eChuDeThiInActionsObj,
    "CHU_DE_THI_IN",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eChuDeThiInActionsObj,
    "CHU_DE_THI_IN",
    "DELETE_MULTIPLE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eChuDeThiInActionsObj,
    "CHU_DE_THI_IN",
    "DELETE_MULTIPLE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
